
import React from "react";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { LinkCountsData } from "@/hooks/admin/accounts/useLinkCountsApi";

interface LinkCountBadgeProps {
  accountId: string;
  linkCounts: LinkCountsData;
  isLoading: boolean;
  error: Error | null;
  onRefresh: () => void;
}

const LinkCountBadge = ({ 
  accountId, 
  linkCounts, 
  isLoading, 
  error, 
  onRefresh 
}: LinkCountBadgeProps) => {
  if (isLoading && !linkCounts[accountId]) {
    return <Skeleton className="h-4 w-16" />;
  }
  
  if (error) {
    return (
      <Badge variant="destructive" className="cursor-pointer" onClick={onRefresh}>
        Error
      </Badge>
    );
  }
  
  const count = linkCounts[accountId];
  if (!count) return "0/0";
  
  return (
    <Badge 
      variant="outline" 
      className="font-mono cursor-pointer hover:bg-muted"
      onClick={onRefresh}
    >
      {`${count.usedLinks}/${count.totalLinks}`}
    </Badge>
  );
};

export default LinkCountBadge;
